import axios from 'axios';
import { omit } from 'ramda';

import { BASE_URL } from 'constants/urls';

axios.defaults.timeout = 5 * 60 * 1000;

export function setBaseUrl(base = BASE_URL) {
    axios.defaults.baseURL = base;
}

export function addDefaultHeader(header, value) {
    axios.defaults.headers.common[header] = value;
}

export function removeDefaultHeader(header) {
    omit([header], axios.defaults.headers.common);
}

export function getDefaultHeader(header) {
    return axios.defaults.headers.common[header];
}

axios.fullAll = async (requests) => {
    const responses = [];
    const errors = [];

    for (var request of requests) {
        try {
            const response = await request;
            responses.push(response);
        } catch (error) {
            errors.push(error);
        }
    }

    return await errors.length ? Promise.reject({ errors, responses }) : responses;
};
